export const SYNC_STATUS = {
  NOT_SYNCED: "not_synced",
  ERROR: "error",
  IN_PROGRESS: "in_progress",
  SYNCED: "synced",
};
